import { CONTENT_CODE } from 'configs/notification';
import Routes from 'utils/Route';

const navigateReceiveCertificateRequest = (params) => {
  const { certificate_request_id } = params || {};
  return Routes.ReviewCertificateRequest(certificate_request_id);
};

const navigateTransferOwnershipRecipient = () => {
  return `${Routes.ManageArtwork}?tab=3`;
};

const navigateApproveCertificateRequest = (params) => {
  const { certificate_code } = params || {};
  const query = new URLSearchParams({
    tab: 0,
    ...(certificate_code ? { highlight_certificate_code: certificate_code } : {}),
  });
  return `${Routes.ManageCertificate}?${query.toString()}`;
};

const NAVIGATE_MAP = {
  [CONTENT_CODE.RECEIVE_CERTIFICATE_REQUEST]: navigateReceiveCertificateRequest,
  [CONTENT_CODE.TRANSFER_OWNERSHIP_RECIPIENT]: navigateTransferOwnershipRecipient,
  [CONTENT_CODE.APPROVE_CERTIFICATE_REQUEST]: navigateApproveCertificateRequest,
};

export const getNavigateRoute = (contentCode, params) => {
  const navigateFunction = NAVIGATE_MAP[contentCode];

  if (!navigateFunction) {
    return null;
  }

  const path = navigateFunction(params);
  return path;
};
